const replaceSpaces = (s: string) => s.replace(/\s/g, ' ');

const maskDigits = (s: string, visibleDigits: number) => {
  let count = 0;
  return s.replace(/\d/g, (d) => (++count <= visibleDigits ? d : 'X'));
};

export const maskPhoneNumber = (phoneNumber: string, visibleDigits: number): string => {
  if (!phoneNumber) {
    console.error('Phone number is required');
    return '';
  }
  return maskDigits(replaceSpaces(phoneNumber), visibleDigits);
};
